import type { ReactNode } from 'react';

export const symbol_flip_camera_android: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-128 0-230-72.5T106-343q-5-12 1-23t18-15q12-3 23 3.5t16 18.5q37 99 123.5 159T480-140q98 0 180.5-50.5T788-328H687q-13 0-21.5-9t-8.5-22q0-13 9-21.5t22-8.5h162q13 0 21.5 8.5T880-359v170q0 12-8.5 20.5T851-160q-12 0-21-9t-9-21v-79q-57 88-147 138.5T480-80Zm0-741q-97 0-179 51T173-633h101q13 0 21.5 8.5T304-603q0 13-8.5 22t-21.5 9H110q-13 0-21.5-8.5T80-602v-168q0-13 8.5-21.5T110-800q13 0 21.5 8.5T140-770v77q57-88 146.5-137.5T480-880q128 0 230 71.5T854-620q5 12-1 23.5T835-581q-12 4-22.5-2.5T797-602q-37-99-123.5-159T480-821Zm-71 412q-30-30-30-72t30-72q30-30 72-30t72 30q30 30 30 72t-30 72q-30 30-72 30t-72-30Z"
		/>
	</svg>
);
